import React, { useEffect, useState } from "react";
import { useRepeatOrders } from "./store";
import { createSortHandler, fourPlaceHolder, getFormattedDate } from "modules/utilities/utility";
import SoftBadge from "modules/common/SoftBadge";
import { Link } from "react-router-dom";
import PaginationDiv from "modules/pagination/PaginationDiv";
import ListFilter from "assets/svgs/list_filter/ListFilter";
import OrderFilter from "./OrderFilter";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import moment from "moment";

function RepeatOrder({subTab}) {
  const { repeatOrdersData, fetchRepeatOrders, repeatLoading } = useRepeatOrders();
  const [repeatOrders, setRepeatOrders] = useState();
  const [pagination, setPagination] = useState();
  const [page, newPage] = useState(1);
  const [filterArray, setFilterArray] = useState();
  const [sortedData, setSortedData] = useState([]);
  const [count, setCount] = useState(0);
  const [opa, setOpa] = useState("");
  useEffect(() => {
    if(subTab=="openOrder"){
      fetchRepeatOrders(page, "repeat", filterArray);
    }
  }, [page, filterArray, subTab]);
  useEffect(() => {
    setRepeatOrders(repeatOrdersData.data);
    setPagination(repeatOrdersData.pagination);
    setSortedData(repeatOrdersData.data);
  }, [repeatOrdersData]);

  const handleSortCreatedDate = ()=> 
  createSortHandler(
  "createdAt",
  count,
  setCount,
  setSortedData,
  setOpa,
  repeatOrders || []
);

  return (
    <div>
      {repeatLoading?fourPlaceHolder(): repeatOrders ? (
        <>
          <table className="d-flex flex-column m-2 shadow">
            <thead
              className="d-flex text-gray rounded-top"
              style={{ backgroundColor: "rgb(234,240,252)" }}
            >
              <th className="flex-1 fw-bold text-secondary  py-3 px-2">Name</th>
              <th className="flex-1 fw-bold text-secondary  py-3 px-2">
                New/ Repeat
              </th>
              <th className="flex-1 fw-bold text-secondary  py-3 px-2">
                <span className="d-flex flex-row gap-4">
                  <span>Order status</span>
                  <span>
                    <OrderFilter setActionableFilter={setFilterArray} />
                  </span>
                </span>
              </th>

              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    {count == 0 ? (
                      <span className="fs-1">Click to sort ascending</span>
                    ) : count == 1 ? (
                      <span className="fs-1">Click to sort Descending</span>
                    ) : (
                      <span className="fs-1">Click to cancel sort</span>
                    )}
                  </Tooltip>
                }
              >
                <th
                  className="flex-1 fw-bold text-secondary text-center py-3 px-2 cursor-pointer"
                  onClick={handleSortCreatedDate}
                >
                  <span className="px-4">Time</span>

                  <div
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                      paddingLeft: "1rem",
                    }}
                  >
                    <div
                      className={
                        opa === ""
                          ? "opacity-100"
                          : opa === "asc"
                          ? "opacity-50"
                          : "opacity-100"
                      }
                    >
                      <AscendingLogoGrey />
                    </div>
                    <div
                      className={
                        opa === ""
                          ? "opacity-100"
                          : opa === "dsc"
                          ? "opacity-50"
                          : "opacity-100"
                      }
                    >
                      <DescendingLogoGrey />
                    </div>
                  </div>
                </th>
              </OverlayTrigger>
            </thead>
            <div
              style={{ height: "50vh", overflowY: "scroll" }}
              className="scrollable-container"
            >
              {sortedData?.map((order, index) => {
                return (
                  <tr
                    id="table-row-value"
                    className={`flex-1 border border-top-0 d-flex justify-content-between ${
                      index === sortedData.length - 1 && `rounded-bottom`
                    }`}
                  >
                    <Link
                      to={`/lead-details/${order.case_id}`}
                      style={{ gap: 0.4 }}
                      className="flex-1 d-flex flex-column p-2"
                    >
                      <td className="text-primary text-capitalize fw-bold text-break">
                        {order.case.user.first_name}
                      </td>
                      <td className="text-primary text-capitalize fw-bold text-break">
                        <SoftBadge bg="secondary" className="text-black">
                          {order.order_display_id}
                        </SoftBadge>
                        <SoftBadge bg="success" className="mx-2">
                          {order.order_type}
                        </SoftBadge>
                      </td>
                    </Link>
                    <td className="flex-1 text-center p-2  align-self">
                      <SoftBadge bg={order.count === 1 ? "warning" : "primary"}>
                        {order.count === 1
                          ? "NEW"
                          : `REPEAT ORDER ${order.count}`}
                      </SoftBadge>
                    </td>
                    <td className="flex-1 text-center p-2  align-self">
                      <SoftBadge bg="primary">{order.status}</SoftBadge>
                    </td>
                    <td className="flex-1 text-center p-2  text-black align-self">
                      {getFormattedDate(order.created_at)}
                    </td>
                  </tr>
                );
              })}
            </div>
          </table>
          <PaginationDiv newPage={newPage} paginationData={pagination} />
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default RepeatOrder;
